import { Chip } from '@mui/material';

interface Entity {
  ['health-status']?: { status?: string };
  aggregate?: {
    inbound_unhealthy_count?: number;
    outbound_unhealthy_count?: number;
    inbound_healthy_count?: number;
    outbound_healthy_count?: number;
  };
}

export const HealthStatus = ({ entity }: { entity: Entity }) => {
  const rawStatus = entity['health-status'] && entity['health-status'].status;

  let status = 'Unknown';
  let color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning' = 'default';
  if (rawStatus === 'healthy') {
    status = 'Healthy';
    color = 'success';
  } else if (rawStatus === 'unhealthy') {
    status = 'Unhealthy';
    color = 'error';
  } else if (entity['aggregate']) {
    // implicit health
    if (
      (entity['aggregate']['inbound_unhealthy_count'] || 0) > 0 ||
      (entity['aggregate']['outbound_unhealthy_count'] || 0) > 0
    ) {
      status = 'Unhealthy';
      color = 'error';
    } else if (
      (entity['aggregate']['inbound_healthy_count'] || 0) > 0 ||
      (entity['aggregate']['outbound_healthy_count'] || 0) > 0
    ) {
      status = 'Healthy';
      color = 'success';
    }
  }
  return <Chip label={status} color={color} />;
};
